import React from 'react';
import callApi from './../../utils/apicaler';
import axios from 'axios';
import {
  Link
} from "react-router-dom"; 

class ProductsSale extends React.Component{
    constructor(props){
            super(props);
            this.state = {
                status:0,
                listProducts:[],
                days:"",
                hours:"", 
                mins:"",
                secs:""

            }
    }
    componentDidMount(){
        callApi('5f1b03fe6c6c7f0072c612af', 'GET', null).then(res =>{
            this.setState({
                listProducts:res.data
            })
        })
    }
  
    showTable = (datas, status) =>{
        var result = null;
            result = datas.slice(0,4).map((product, index)=>{
                return ( product.sale === "SALE" || product.sale === "HET HANG" ?
                    <div className="col-xs-6 col-sm-4 col-md-4 col-lg-3" style={{paddingRight:"6px", paddingLeft: "6px"}} key={index}>
                        <Link to={`product/${product._id}`}>
                            <div className="colection1" >

                            <p style={{background:"red"}}>{product.sale === "HET HANG" ? "Hết hàng" : `Sale ${product.salePrice}`}</p>
                            <img src={product.imgeFile} />

                            </div>
                            <div className="title_product">
                                <b>{product.products.slice(0,28)}...</b>
                                <hr/>
                                <span style={{textDecoration: product.sale === "SALE" || product.sale === "HET HANG" ? "line-through" : ""}}>Gia {product.price}.000 Vnd</span>
                                <br/>
                                <b style={{fontSize:"21px", color:"red", textDecoration:product.sale === "HET HANG" ? "line-through" : ""}}>{((parseInt(product.price)*(1 - parseInt(product.salePrice)/100.0)))}.000VND</b>
                            </div>
                        </Link>
                    </div> 
                    : 
                    ""
                )
            })
        return result
    }

    render(){
        const {status, days, hours, mins, secs} = this.state;
        var ab = [];
        const listProducts = this.state.listProducts.filter((list)=>{
            if(list.sale === "SALE" || list.sale === "HET HANG"){
                ab.push(list)
            }
           
        })
        var expiry = new Date("August 9,2020 24:00:00");
        setInterval(()=> {
            var ongo=new Date().getTime();
            var timeleft=expiry-ongo;
            var days=Math.floor(timeleft/(1000*60*60*24));
            var hours=Math.floor(timeleft%(1000*60*60*24)/(1000*60*60));
            var mins=Math.floor(timeleft%(1000*60*60)/(60*1000));
            var secs=Math.floor(timeleft%(60*1000)/(1000));
            if(timeleft>0) {
                this.setState({days:days,hours:hours,mins:mins,secs:secs})
            }
           
        },1000);

        return(
            <div className="row custom_row">
                
                <div className="out_soure">
                    <div className="img_out" style={{background:"none",height:"229px"}}>
                        <div className="deb">
                            <span className="t1"> <b>●</b> &nbsp;TIME out</span><br/>
                            <span style={{fontSize:"20px", color:"red"}} id="main" onLoad="">{days} &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{hours}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{mins}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{secs}</span>
                            <br/><span style={{padding:0, textDecoration:"line-through", fontFamily: 'Ubuntu'}} className="t1">&nbsp;&nbsp;&nbsp;Ngày : Giờ : phút : giây</span>
                        </div>
                    </div>
                </div>
                <div className="box_main">
                    {
                        listProducts ? 
                        this.showTable(ab, status) : 
                        <div className="loading" style={{marginTop:"0", padding:"40px"}}>Loading&#8230;</div>
                    }
                </div>
                <div className="row custom_row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                        <div className="send_mail">
                            <Link to="/sale">
                                <button type="button"> Xem thêm </button>
                            </Link>
                        </div>
                    </div>
                </div>
                
            </div>
            
        )
    }
}



export default ProductsSale;